import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authApi from '../../services/Api/authApi';

// Thunk for adding notifier email
export const addNotifierEmail = createAsyncThunk(
  'auth/addNotifierEmail',
  async (emails, { rejectWithValue }) => {
    try {
      const response = await authApi.addNotifierEmail({ emails });
      return response.data; // Assuming the API returns { data: { success, message, related_emails }}
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Something went wrong.'
      );
    }
  }
);

// Thunk for removing notifier email
export const removeNotifierEmail = createAsyncThunk(
    'auth/removeNotifierEmail',
    async (emails, { rejectWithValue }) => {
      try {
        const response = await authApi.removeNotifierEmail(emails); // ✅ correct
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Something went wrong.');
      }
    }
  );


// Initial state
const initialState = {
  loading: false,
  error: null,
  data: null,
  message: '',
  relatedEmails: [],
};

const notifierSlice = createSlice({
  name: 'notifier',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Add Notifier Email
      .addCase(addNotifierEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNotifierEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message; // Set success message
        state.relatedEmails = action.payload;
      })
      .addCase(addNotifierEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Remove Notifier Email
      .addCase(removeNotifierEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeNotifierEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message; // Set success message
        state.relatedEmails = action.payload;
      })
      .addCase(removeNotifierEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default notifierSlice.reducer;
